<template>
  <div>
    <Loading :isActive="loading"/>
    <component
      :is="currentComponent"
      :parametro="currentParam"
      :update="updateParam"
      :close="closeEdit"
      :descSingular="descSingular"
      :filiais="filiais"
    />
    <ModalInfoMarkdown
      :titulo="currentParam.desc"
      :conteudo="currentParam.documentacao"
      :close="closeInfo"
    />
    <crud-base
      :url="url"
      :columns="columns"
      :enableSearch="true"
      :show-actions="true"
      :reload="shouldReload"
      :filters="filtros"
      :useQueryString="false"
      @reload="setReload"
    >
      <template v-slot:descricao="{model}">
        <template v-if="model.tipo === 'TRANSLATE'">
          <div>
            {{ model.desc }}
            <br>
            <br>
          </div>
          <div>
            <strong>{{ model.valor ? model.valor.label : 'Título não informado' }}</strong>
          </div>
          <div>
            <small>{{ model.valor ? model.valor.valor : 'Descrição não informada' }}</small>
          </div>

        </template>
        <template v-else>
          {{ model.desc }}
          <small>{{ model.valor | tipo(model.tipo, model.opcoes) }}</small>
        </template>
      </template>

      <template v-slot:filter-search>
        <select v-model="filtros.sistema" class="form-control form-control-sm ml-2" style="width: auto; min-width: 140px;">
          <option value="">Todos os sistemas</option>
          <option v-for="sistema in sistemas" :key="sistema" :value="sistema">{{ sistema }}</option>
        </select>
      </template>

      <template v-slot:action-buttons="{model}">
        <CButton
            size="sm"
            v-show="model.has_documentacao"
            color="info"
            @click="openInfo(model)" title="Informações detalhadas">
          <fa-icon icon="info-circle"/>
        </CButton>

        <CButton color="primary" size="sm" @click="openEdit(model)">
          <fa-icon icon="pencil-alt"/>
        </CButton>

        <LogAlteracaoDados
          tabela="parametro_geral"
          :chave="model.chave"
        />
      </template>

    </crud-base>
  </div>
</template>

<script>

import Edit from './Edit';
import ModalInfoMarkdown from '@/components/ModalInfoMarkdown';

import {
  toDecimal,
  toMonetary
} from "@/helpers/utils";
import clone from "just-clone";
import {get, put} from "@/helpers/apiRequest";
import {loadCargas} from "@/helpers/cargas";
import config from "@/config";
import _orderBy from "lodash/orderBy";
import CrudBase from "../../components/crud/CrudBase";

export default {
  name: "ListaParametros",
  components: {
    Edit,
    ModalInfoMarkdown,
    CrudBase
  },
  props: [
    "url",
    "descPlural",
    "descSingular",
    "reload",
  ],
  data() {
    return {
      columns: [
        {label: 'Parâmetro', field: 'descricao', sortable: false, useSlot: true},
      ],
      loading: false,
      shouldReload: false,
      currentComponent: null,
      currentParam: {},
      filiais: [],
      sistemas: [],
      filtros: {
        sistema: '',
      },
    };
  },
  filters: {
    tipo(valor, tipo, opcoes) {
      switch (tipo) {
        case 'WYSIWYG':
        case 'TYPE_KEYVALUE':
        case 'INTEGRATION':
        case 'JSON':
        case 'EMAIL':
        case 'TEL':
          return 'Parâmetro de múltiplas opções';

        case 'CURRENCY':
          return toMonetary(valor);

        case 'PERCENT':
          return toDecimal(valor);

        case 'SELECT':
          return opcoes[valor] || valor;

        case 'IMAGE':
        case 'BOOLEAN':
          if (valor) return 'Sim';
          return 'Não';

        default:
          return valor;
      }
    },
  },
  methods: {
    setReload(shouldReload) {
      this.shouldReload = shouldReload;
    },
    loadSistemas() {
      get(`${this.url}/sistemas`)
          .then((sistemas) => {
            this.sistemas = sistemas || [];
          })
          .catch(() => {
            this.sistemas = [];
          });
    },
    importComponent(componentName, modalName = null) {
      return import(`${componentName}`)
          .then((component) => {
            this.currentComponent = component.default;
            setTimeout(() => this.$modal.show(modalName || componentName), 0);
          });
    },
    openInfo(parametro) {
      this.currentParam = clone(parametro);
      this.loadParametroDetalhes();
      this.$modal.show('modalInfoMarkdown');
    },
    closeInfo() {
      this.$modal.hide('modalInfoMarkdown');
    },
    openEdit(parametro) {
      this.currentParam = clone(parametro);
      this
        .importComponent(`./Avancado/${parametro.chave}`, parametro.chave)
        .catch(() => this.importComponent('./Edit', 'parametroEdit'));
    },
    closeEdit() {
      this.$modal.hide(this.currentComponent.name);
    },
    loadParametroDetalhes() {
      this.loading = true;

      get(`/admin/parametros/${this.currentParam.chave}`)
          .then((json) => {
            this.currentParam = json;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
    },
    parseNumerics(obj, type) {
      if (type !== 'TYPE_KEYVALUE') {
        return obj;
      }

      for (const key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        const value = obj[key];

        if (typeof value === 'object' && value !== null) {
          this.parseNumerics(value, type);
        }
        
        // Se o valor é um número inteiro mas em formato de string, faz a conversão para inteiro
        if (typeof value === 'string' && /^-?\d+$/.test(value)) {
          obj[key] = parseInt(value, 10);
        }
      }

      return obj;
    },
    updateParam(parametro) {
      if(this.currentComponent.name === "INDICE_BUSCA") {
        this.currentParam = parametro
      }
      
      if (this.currentParam.conteudo && this.currentParam.tipo === "WYSIWYG") {
        this.currentParam.valor = this.currentParam.conteudo;
      }

      const param = {
        chave: this.currentParam.chave,
        valor: this.parseNumerics(this.currentParam.valor, this.currentParam.tipo),
        filiais: this.currentParam.filiais,
      };

      loadCargas(
          config.token(),
          () => {
            localStorage.setItem('revalidar_carga', 0);
          }
      );

      this.loading = true;
      put(`${this.url}/${param.chave}`, param)
          .then((json) => {
            this.$swal({
              title: 'Salvo com sucesso',
              text: json.message,
              showCancelButton: false,
              cancelButtonText: 'Fechar',
              showConfirmButton: true,
              icon: 'success',
            });
          })
          .catch((error) => {
            this.loading = false;
            this.$swal({
              title: 'Falha ao Salvar',
              text: error.message,
              showCancelButton: true,
              cancelButtonText: 'Fechar',
              showConfirmButton: false,
              icon: 'error',
            });
          })
          .then(() => {
              this.loading = false;
              this.shouldReload = true;
          })
          .then(() => this.closeEdit());
    },
  },
  beforeMount() {
    const {filiais} = JSON.parse(localStorage.getItem('app'));
    this.filiais = _orderBy(filiais, 'id');
    this.loadSistemas();
  }
}
</script>